let BannerBoxStyle = {
  ContainerNormal :{color: "#fff"},
  ContainerDotted : {color: "#fff", borderRightStyle: "dotted", borderRightColor: "#fff",width:"30%"},
  ItemData:{color: "#ff8000",fontWeight:"400"},
  ItemFooter:{color: "#ff8000",fontWeight: "400"}
}

export {BannerBoxStyle};